import { useLazyQuery, useQuery } from "@apollo/client";
import { Box, Button, Card, Flex, Heading, Text } from "rebass/styled-components";
import { GET_MY_FORMS_LIST } from "../../../graphql/queries";
import { IGetMyHealthCoachFormsListOutput, IGetMyHealthCoachFormsListInput, IHealthCoachFMyHealthCoachFormsListOutputTmp, IHealthCoachFMyHealthCoachFormsListOutputFrm, IGetMyHealthCoachFormsList } from "../../../graphql/types/queries/forms";
import PleaseWait from "../../../components/PleaseWait";
import styled from "styled-components";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Modal from "styled-react-modal";
import { useState } from "react";
import { SpecialModalBackground } from "../../../components/Commons";
import { IProperties } from "../builder/types";
import { IFormMeta } from "../builder/Builder";
import withSession, { IWithSession } from "../../../lib/withSession";
import { EditModalLibrary } from "./EditModalLibrary";
import { Constants } from "../../../utils/Constants";
import SwitchSelector from "react-switch-selector";
import { EditModalOthers } from "./EditModalOthers";
import { IUser } from "../../../graphql/types/queries/user";
import { Input } from "../../../components/TextInput";

const Btn = styled(Button)``
const Item = styled(Flex)`
  padding: 8px 12px;
  border: 1px solid #a1abbc;
  border-radius: 10px;
  margin-left: 12px;
  cursor: pointer;
    ${Btn} {
      opacity: 0;
    }

  &:hover {
    border: 1px solid rgb(52, 79, 121);
    background: rgb(52, 79, 121);
    color: white;
    ${Btn} {
      opacity: 1;
    }
  }
`

interface IFormsListsProps {
  onPreviewTemplate: (id: string) => void,
  onPreviewForm: (id: string) => void,
}

const Tag = styled(Box)`
  padding: 4px 12px;
  border-radius: 8px;
  margin-right: 12px;
  color: white;
  opacity:0.7;
  font-size: 12px;
`

const IButton = styled.i`
  padding: 4px;
  margin-right: 12px;
  background:  transparent;
  color: rgb(52, 79, 121);
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    background:  rgb(52, 79, 121);
    color: white;
  }
`

const GetTags: React.FC<{
  frm: IHealthCoachFMyHealthCoachFormsListOutputFrm
}> = ({ frm }) => {
  return (
    <Flex mt={3}>
      {frm.isActive ? (
        <Tag backgroundColor={'rgb(52, 121, 69)'}>Active</Tag>
      ) : (
        <Tag backgroundColor={'rgb(91, 92, 91)'}>Deactivated</Tag>
      )}
      {frm.isDeleted && <Tag backgroundColor={'rgb(96, 54, 54)'}>Deactivated</Tag>}
    </Flex>
  )
}
const GetUpdatedMustReorderTagOther: React.FC<{
  form: IHealthCoachFMyHealthCoachFormsListOutputFrm,
  templates: Array<IHealthCoachFMyHealthCoachFormsListOutputTmp>
  user: IUser
}> = ({ form, templates, user }) => {
  const template = templates.find(x => x.id === form.basedOnTemplate.id)
  if (!template) return null

  if (!form.builderUpdatedAt || moment(form.builderUpdatedAt).isBefore(template.updatedAt)) {
    if (template && form.createdBy.id === user.id) {
      return (
        <Flex mt={3} alignItems={'center'} justifyContent={'center'}>
          <Tag backgroundColor={'#eb6900'}>The template has been updated. It means some new fields might have been added. Please edit form to reorder potential new fields and save.</Tag>
        </Flex>)
    } else {
      return (
        <Flex mt={3} alignItems={'center'} justifyContent={'center'}>
          <Tag backgroundColor={'#eb6900'}>The template has been updated. It means some new fields might have been added. Please contact {form.createdBy.displayName} to update.</Tag>
        </Flex>)
    }
  }

  return null
}

const GetUpdatedMustReorderTag: React.FC<{
  form: IHealthCoachFMyHealthCoachFormsListOutputFrm,
  others: Array<IHealthCoachFMyHealthCoachFormsListOutputFrm>,
  templates: Array<IHealthCoachFMyHealthCoachFormsListOutputTmp>
  user: IUser
}> = ({ form, templates, others, user }) => {
  const template = templates.find(x => x.id === form.basedOnTemplate.id)
  if (!template) return null

  if (!form.builderUpdatedAt || moment(form.builderUpdatedAt).isBefore(template.updatedAt)) {
    if (form.formCreatorId === user.id) {
      return (
        <Flex mt={3} alignItems={'center'} justifyContent={'center'}>
          <Tag backgroundColor={'#eb6900'}>The template has been updated. It means some new fields might have been added. Please edit form to reorder potential new fields and save.</Tag>
        </Flex>)
    } else {
      return (
        <Flex mt={3} alignItems={'center'} justifyContent={'center'}>
          <Tag backgroundColor={'#eb6900'}>The template has been updated. It means some new fields might have been added. Please contact {form.formCreatorDisplayName} to update.</Tag>
        </Flex>)
    }
  }

  return null
}


const TabsContainer = styled(Flex)`
  background: transparent;
  margin-left: ${() => `-${Constants.OUTLETS_PADDING_MOBILE}px`};
  margin-right: ${() => `-${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding: ${() => `3px ${Constants.OUTLETS_PADDING_MOBILE}px`};
  height: 50px;
  min-height: 80px;
  overflow-x: auto;
  text-align: center;
  @media screen and (min-width: 68.8125em) {
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 3px 6px;
overflow-x: hidden;
  min-height: 50px;
  }
`


const FormsLists: React.FC<IFormsListsProps & IWithSession> = ({ onPreviewTemplate, onPreviewForm, session }) => {
  const navigate = useNavigate()
  const [showDeactivated, setShowDeactivated] = useState(false)
  const [showOptionsLibrary, setShowOptionLibrary] = useState<{ form: IHealthCoachFMyHealthCoachFormsListOutputFrm, targetId: string } | null>()
  const [showOptionsOthers, setShowOptionOthers] = useState<{ form: IHealthCoachFMyHealthCoachFormsListOutputFrm, targetId: string } | null>()
  const [selectedView, setSelectedView] = useState<IGetMyHealthCoachFormsList | null>(null)
  const { data, loading, error, refetch } = useQuery<IGetMyHealthCoachFormsListOutput, IGetMyHealthCoachFormsListInput>(GET_MY_FORMS_LIST, {
    onCompleted: e => {
      setSelectedView(e.getMyHealthCoachFormsList[0])
    }
  })
  console.log({ selectedView, session })
  return (
    <Flex flexDirection={'column'} p={4} maxWidth={'1200px'} backgroundColor={'white'} height={'100%'} style={{ paddingBottom: 0 }}>
      <Flex justifyContent={'center'} alignItems={'center'} mb={!!loading?4:2}>
        <Heading mr={3}>Forms</Heading>
        <IButton className="fa-solid fa-arrows-rotate" onClick={() => refetch()}></IButton>
      </Flex>
      {!!loading ? (
        <PleaseWait />
      ) : (
        <>
          <Flex justifyContent={'center'} mb={4}>
            <Input
              type="checkbox"
              checked={showDeactivated}
              onClick={(e: any) => setShowDeactivated(e.target.checked)}
              id={'showDeact'}
              name={'showDeact'}
            />
            <label htmlFor={'showDeact'} style={{ marginLeft: '16px' }}>
              Show deactivated/deleted forms
            </label>
          </Flex>
          <TabsContainer mb={4}>
            <Box minWidth={['1000px', '100%', '100%']} paddingBottom={['8px', 'initial', 'initial']}>
              <SwitchSelector
                onChange={(val) => {
                  setSelectedView((data?.getMyHealthCoachFormsList || [] as any).find((x: IGetMyHealthCoachFormsList) => x.target.id === val))
                }}
                // onChange={(val) => setselectedView(val as any)}
                name='ssSelectedView'
                options={data?.getMyHealthCoachFormsList.map(x => {
                  return {
                    label: x.target.target,
                    value: x.target.id,
                    selectedBackgroundColor: "#344F7A",
                    disabled: true
                  }
                }) || []}
                initialSelectedIndex={0}
                backgroundColor={"transparent"}
                fontColor={"#344F7A"}
                selectedFontColor={"white"}
                selectedBackgroundColor={"#344F7A"}

              />
            </Box>
          </TabsContainer>
          {!!selectedView && (
            <Flex flexDirection={'column'} style={{ overflowY: 'auto', paddingBottom: '48px' }}>
              <Flex alignItems={'center'} justifyContent={'center'}>
                {(!selectedView.mine || selectedView.mine.length < 1) && (
                  <i className="fas fa-exclamation-triangle" style={{ color: 'red', marginRight: '12px' }}></i>
                )}
                <Text fontSize={'18px'} fontWeight={600}>{selectedView.target.target}</Text>
              </Flex>
              {!selectedView.target.multipleAllowed && (
                <Text textAlign={'center'} color='red' fontWeight={300} mt={3}>This target allow only one active form per user</Text>
              )}
              <Text mt={4} fontWeight={600}>Available templates:</Text>
              <Text mt={2} style={{ fontStyle: 'italic' }}>Click on to create a new form based on the template:</Text>
              {!selectedView.template || selectedView.template.length < 1 ? (
                <Text mt={2} textAlign={'center'} style={{ fontStyle: 'italic' }}>No template existing</Text>
              ) : (
                <>
                  {selectedView.template.map(template => {
                    return (
                      <Item mt={2} onClick={() => {
                        navigate('/form-builder', { state: { useTemplateId: template.id, useTargetId: selectedView.target.id } });
                      }}>
                        <Flex flex={1}>
                          <Flex flexDirection={'column'} flex={1}>
                            <Text fontWeight={600}>{template.name}</Text>
                            {template.description && (
                              <Text mt={2}>{template.description}</Text>
                            )}
                            <Text mt={3} fontWeight={300} fontSize={'12px'} fontStyle={'italic'}>created by {template.creator.firstName} - last update {moment(template.updatedAt).format('MM/DD/YYYY hh:mmA')}</Text>
                          </Flex>
                          <Btn variant={'pink'} alignSelf={'center'} style={{ padding: '6px 12px', fontSize: '12px' }} ml={2} onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            if (!!onPreviewTemplate) {
                              onPreviewTemplate(template.id)
                            }
                          }}>Preview</Btn>
                        </Flex>
                      </Item>
                    )
                  })}</>
              )}
              <Text mt={4} fontWeight={600}>Existing forms (created by others):</Text>
              {!selectedView.others || selectedView.others.filter(xx=>{
                    if(showDeactivated) return true

                    if(xx.isDeleted || !xx.isActive) return false

                    return true
                  }).length < 1 ? (
                <Text mt={2} textAlign={'center'} style={{ fontStyle: 'italic' }}>No other forms existing</Text>
              ) : (
                <>
                  {selectedView.others.filter(xx=>{
                    if(showDeactivated) return true

                    if(xx.isDeleted || !xx.isActive) return false

                    return true
                  }).map(template => {
                    return (
                      <Item mt={2}>
                        <Flex flex={1}>
                          <Flex flexDirection={'column'} flex={1}>
                            <Text fontWeight={600}>{template.name}</Text>
                            {template.description && (
                              <Text mt={2}>{template.description}</Text>
                            )}
                            <Text mt={3} fontWeight={300} fontSize={'12px'} fontStyle={'italic'}>created by {template.createdBy.displayName === session.displayName ? 'You' : template.createdBy.displayName} - last update {moment(template.updatedAt).format('MM-DD-YYYY hh:mmA')}</Text>
                            <GetTags frm={template} />
                            <GetUpdatedMustReorderTagOther user={session} templates={selectedView.template} form={template} />
                          </Flex>
                          <Flex flexDirection={'column'} ml={2} justifyContent={'center'}>
                            <Btn variant={'pink'} alignSelf={'center'} style={{ padding: '6px 12px', fontSize: '12px' }} onClick={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              if (!!onPreviewForm) {
                                onPreviewForm(template.id)
                              }
                            }}>Preview</Btn>
                            <Btn variant={'primary'} alignSelf={'center'} style={{ padding: '6px 12px', fontSize: '12px' }} mt={2} onClick={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              if (!!onPreviewForm) {
                                setShowOptionOthers({
                                  form: template,
                                  targetId: selectedView.target.id
                                })
                              }
                            }}>Options</Btn>
                          </Flex>
                        </Flex>
                      </Item>
                    )
                  })}</>
              )}
              <Text mt={4} fontWeight={600}>In your library:</Text>
              {!selectedView.mine || selectedView.mine.filter(xx=>{
                    if(showDeactivated) return true

                    if(xx.isDeleted || !xx.isActive) return false

                    return true
                  }).length < 1 ? (
                <Flex flexDirection={'column'}>
                  <Text mt={2} textAlign={'center'} style={{ fontStyle: 'italic' }}>No forms in your library</Text>
                  <Text mt={2} textAlign={'center'} color='red'>You must have at least an active form</Text>
                </Flex>
              ) : (
                <>
                  {selectedView.mine.filter(xx=>{
                    if(showDeactivated) return true

                    if(xx.isDeleted || !xx.isActive) return false

                    return true
                  }).map(template => {
                    return (
                      <Item mt={2}>
                        <Flex flex={1}>
                          <Flex flexDirection={'column'} flex={1}>
                            <Flex alignItems={'center'}>
                              {template.isFavorite && (
                                <i className="fa-solid fa-star" style={{ marginRight: '12px', color: '#cece00' }}></i>
                              )}
                              <Text fontWeight={600}>{template.name}</Text>
                            </Flex>
                            {template.description && (
                              <Text mt={2}>{template.description}</Text>
                            )}
                            <Text mt={3} fontWeight={300} fontSize={'12px'} fontStyle={'italic'}>created by {template.createdBy.displayName === session.displayName ? 'You' : template.createdBy.displayName} - last update {moment(template.updatedAt).format('MM-DD-YYYY hh:mmA')}</Text>
                            <GetTags frm={template} />
                            <GetUpdatedMustReorderTag user={session} templates={selectedView.template} form={template} others={selectedView.others} />
                          </Flex>
                          <Flex flexDirection={'column'} ml={2} justifyContent={'center'}>
                            <Btn variant={'pink'} alignSelf={'center'} style={{ padding: '6px 12px', fontSize: '12px' }} onClick={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              if (!!onPreviewForm) {
                                onPreviewForm(template.id)
                              }
                            }}>Preview</Btn>
                            <Btn variant={'primary'} alignSelf={'center'} style={{ padding: '6px 12px', fontSize: '12px' }} mt={2} onClick={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              setShowOptionLibrary({
                                form: template,
                                targetId: selectedView.target.id
                              })
                            }}>Options</Btn>
                          </Flex>
                        </Flex>
                      </Item>
                    )
                  })}</>
              )}
            </Flex>
          )}
        </>
      )}
      {(!!showOptionsLibrary) && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setShowOptionLibrary(null);
          }}
          onEscapeKeydown={() => {
            setShowOptionLibrary(null);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setShowOptionLibrary(null);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: 'auto',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <EditModalLibrary form={showOptionsLibrary.form} targetId={showOptionsLibrary.targetId} onClose={() => setShowOptionLibrary(null)} session={session} />
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {(!!showOptionsOthers) && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setShowOptionOthers(null);
          }}
          onEscapeKeydown={() => {
            setShowOptionOthers(null);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setShowOptionOthers(null);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: 'auto',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <EditModalOthers onClose={() => setShowOptionOthers(null)} form={showOptionsOthers.form} targetId={showOptionsOthers.targetId} session={session} />
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
    </Flex>
  );
}

export default withSession(FormsLists)